import axios, { AxiosRequestConfig } from 'axios';
import countries from 'i18n-iso-countries';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
    countryCode: (localStorage.getItem('countryCode') || process.env.REACT_APP_COUNTRYCODE) as string,
    languageCode: localStorage.getItem('languageCode') || (process.env.REACT_APP_LANGUAGECODE) as string,
  },
});

const reqInterceptor = async (req: AxiosRequestConfig) => {
  req.headers = {
    ...req.headers,
  }
  return req;
};

const msdsPdsInterceptor = (res: any) => {
  const URL_MATCH_REGEX = /(recommendations|products)(\/?\d+|\??vehicleId=*)/;
  const {
    config: {
      url,
      headers: { countryCode },
    },
  } = res;
  const countryAlpha2 = countries.alpha3ToAlpha2(countryCode);
  const regionNames = new Intl.DisplayNames(["en"], { type: "region" });
  const countryName = regionNames.of(countryAlpha2);

  if (
    ["NZL", "AUS", "MYS"].includes(countryCode) &&
    URL_MATCH_REGEX.test(url)
  ) {
    const match = res.config.url.match(URL_MATCH_REGEX);
    const countryMsdsName = `${countryName} (${countryAlpha2})`;

    if ([match.at(1), match.at(2)].includes("products")) {
      const { id } = res.data;
      if (id && id !== 99999) {
	const msdsUrl = new URL(res.data.msdsUrl);
	const pdsUrl = new URL(res.data.pdsUrl);
	["l", "p"].forEach((item: any) => {
          msdsUrl.searchParams.delete(item);
          pdsUrl.searchParams.delete(item);
	});
	msdsUrl.searchParams.set("c", countryMsdsName);
	pdsUrl.searchParams.set("c", countryMsdsName);
	msdsUrl.searchParams.set("n", res.data.id);
	pdsUrl.searchParams.set("n", res.data.id);
	res.data.msdsUrl = msdsUrl;
	res.data.pdsUrl = pdsUrl;	
      }
    } else {
      res.data.components.forEach((x: any) =>
        processComponentMsdsPds(x, countryMsdsName)
      );
    }
  }

  return res;
};

const processComponentMsdsPds = (component: any, countryMsdsName: string) => {
  if ("recommendedProduct" in component) {
    if ("msdsUrl" in component.recommendedProduct) {
      const { id } = component.recommendedProduct;
      if (id && id !== 99999) {
	const msdsUrl = new URL(component.recommendedProduct.msdsUrl);
	msdsUrl.searchParams.delete("l");
	msdsUrl.searchParams.delete("p");
	msdsUrl.searchParams.set("c", countryMsdsName);
	msdsUrl.searchParams.set("n", id);
	component.recommendedProduct.msdsUrl = msdsUrl.toString();	
      }
    }
    if ("pdsUrl" in component.recommendedProduct) {
      const { id } = component.recommendedProduct;
      if (id && id !== 99999) {
	const pdsUrl = new URL(component.recommendedProduct.pdsUrl);
	pdsUrl.searchParams.delete("l");
	pdsUrl.searchParams.delete("p");
	pdsUrl.searchParams.set("c", countryMsdsName);
	pdsUrl.searchParams.set("n", id);
	component.recommendedProduct.pdsUrl = pdsUrl.toString();	
      }
    }
  }
  if ("alternateProducts" in component) {
    component.alternateProducts.forEach((product: any) => {
      if ("msdsUrl" in product) {
        const { id } = product;
	if (id && id !== 99999) {
          const msdsUrl = new URL(component.recommendedProduct.msdsUrl);
          msdsUrl.searchParams.delete("l");
          msdsUrl.searchParams.delete("p");
          msdsUrl.searchParams.set("c", countryMsdsName);
          msdsUrl.searchParams.set("n", id);
          product.msdsUrl = msdsUrl.toString();	  
	}
      }
      if ("pdsUrl" in product) {
        const { id } = product;
	if (id && id !== 99999) {
          const pdsUrl = new URL(component.recommendedProduct.pdsUrl);
          pdsUrl.searchParams.delete("l");
          pdsUrl.searchParams.delete("p");
          pdsUrl.searchParams.set("c", countryMsdsName);
          pdsUrl.searchParams.set("n", id);
          product.pdsUrl = pdsUrl.toString();	  
	}
      }
    });
  }
}

axiosInstance.interceptors.response.use(msdsPdsInterceptor, function (err) {
  return Promise.resolve(err === null || err === void 0 ? void 0 : err.response);  
});

axiosInstance.interceptors.request.use(reqInterceptor, error => Promise.reject(error));

export const apiInstance = axiosInstance;
